module.exports = __webpack_public_path__ + "img/MPTechModelM.5de94731.png";